/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC, useEffect, useState} from 'react'
import {drawStatusSocket, gameSetting, gameType} from "../../../../constants/config";
import {useAppSelector} from "../../../../redux/hooks/hook";
import {ToastContainer} from "react-toastify";
import {useParams} from "react-router-dom";
import DrawingWrapper from "./DrawingWrapper";
import MainCard from "../../../../../_kiloit/helpers/components/MainCard";
import {HistoryTable} from "./History";
import BettingBoard from "./BettingBoard";
import {moneyFormatter} from "../../../../../_kiloit/helpers/components/MoneyUtils";
import {useGame} from "../../core/action";
import {useConfig} from "../../../config/action";
import {useBalance} from "../../../balance/action";
import {useDispatch} from "react-redux";
import {clearBetting, setCountDown, setDraw} from "../../core/reducer";
import {getDateDDMMYYYY} from "../../../../../_kiloit/helpers/dateUtils";
import RecentBet from "../../../report/sale/components/RecentBet";
import {TDraw} from "../../core/_models";
import RefreshBtn from "../../../../../_kiloit/partials/widgets/RefreshButton";
import {playAudio} from "../../../../../_kiloit/helpers/Audio";
import {getCSize} from "../../../../../_kiloit/helpers/storage";
import {clickId} from "../../../../../_kiloit/helpers/utils";
import {Form} from 'react-bootstrap';
import RecentBetPage from "../../../report/sale/components/ReportPage";
import CountDownTimer from "./CountDownTimer";
import clsx from "clsx";
import {I18n} from "../../../../../_kiloit/i18n/KiloITi18n";

const GameWrapper: FC = () => {
    const game = useAppSelector(state => state.gameState.game);
    const {balance} = useAppSelector(state => state.balance);
    const draw = game.draw;
    const param = useParams();
    const tableId = parseInt(param.id ?? "0");
    const {
        fetchCurrentDraw,
        fetchStatistic,
        subscriptionSocket,
        fetchCurrentBet,
        checkDraw,
    } = useGame();
    const {fetchConfig} = useConfig();
    const {fetchBalance, getOutBl} = useBalance();
    const dispatch = useDispatch();
    const [size, setSize] = useState(3);
    const [selectedOption, setSelectedOption] = useState(0);

    useEffect(() => {
        fetchCurrentDraw(tableId);
        const refreshData = () => {
            fetchConfig(gameSetting);
            fetchStatistic(tableId);
            fetchBalance();
            fetchCurrentBet({size: getCSize(), tableId});
        }
        refreshData();

        subscriptionSocket(`/topic/one-dice:${tableId}`, (ms) => {
            const currentDraw: TDraw = JSON.parse(ms.data);
            checkDraw(currentDraw);
            dispatch(setCountDown(currentDraw.countDown));
            if (ms.type === drawStatusSocket.open) {
                refreshData();
                clickId("clear-am-btn");
            }
            if (ms.type === drawStatusSocket.release) {
                const res = currentDraw.items.filter(e => e.betCode === "SLOT")[0];
                playAudio(`/${res.result}.ogg`);
            }
        });
        return () => {
            dispatch(clearBetting());
            dispatch(setCountDown(-1));
            dispatch(setDraw({}))
        }
        /*eslint-disable-next-line react-hooks/exhaustive-deps*/
    }, []);


    // Event handler to handle radio button changes
    const handleRadioChange = index => setSelectedOption(index);


    return (
        <MainCard def={true}
                  isLoading={false}>
            <div className="row m-0 h-100 overflow-y-scroll">
                <div className="col-3 p-0 report-dice d-none d-lg-block">
                    <div className="d-flex justify-content-between align-items-center text-light ticket-dice p-2">
                        <div><span
                            className="text-light fw-bold fs-5">{getDateDDMMYYYY(null)} #{draw.currentDraw?.drawCode}</span>
                        </div>
                        <RefreshBtn onRefresh={() => fetchBalance()}/>
                    </div>
                    <div className="d-flex justify-content-center align-items-center h-150px">
                        <CountDownTimer className="count-down-dice" time={game.countDown ?? 0}/>
                    </div>
                    <div className="row">
                        <div className="col-6 pe-0 border-end">
                            <div className="text-center ticket-dice py-2">
                                <span className="text-light fw-bold fs-3"> <I18n t={"BALANCE"}/></span>
                            </div>
                            <div className="d-flex align-items-center justify-content-center text-center h-50px">
                                <span
                                    className="text-blue fs-3 fw-bold">{moneyFormatter(balance.balance, balance.currencyCode)}</span>
                            </div>
                        </div>
                        <div className="col-6 ps-0">
                            <div className="text-center ticket-dice py-2">
                                <span className="text-light fw-bold fs-3"> <I18n t={"OUTSTANDING"}/></span>
                            </div>
                            <div className="d-flex align-items-center justify-content-center text-center h-50px">
                                <span
                                    className="text-blue fs-3 fw-bold">{moneyFormatter(getOutBl(tableId).balance, balance.currencyCode)}</span>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center text-light ticket-dice p-2">
                        <div><span className="text-light fw-bold fs-3"> <I18n t={"REPORT"}/></span></div>
                        {/*<RefreshBtn onRefresh={() => fetchCurrentBet({size, tableId: tableId})}/>*/}
                    </div>

                    <div className="text-center mt-1">
                        {/*Form Add to Card*/}
                        {/*<BettingCart/>*/}
                        <RecentBet size={size} setSize={setSize}/>
                    </div>

                </div>
                <div className="col-12 col-lg-9 border position-relative p-0 drawing-wrapper">
                    <DrawingWrapper type={gameType.manual} draw={draw}/>

                    <div className="header d-lg-none bg-secondary p-0">
                        <div className="text-center d-flex justify-content-center align-items-center">
                            <CountDownTimer time={game.countDown ?? 0}/>
                            <div className="text-start">
                                <div>
                                    <span className="fw-bold">
                                        {
                                            getDateDDMMYYYY(null)
                                        }
                                    </span>
                                </div>
                                <div>
                                    <span className="fw-bold">
                                        #{draw.currentDraw?.drawCode}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="text-center">
                            <div>
                                <span className="fw-bold"> <I18n t={"OUTSTANDING"}/></span>
                            </div>
                            <div>
                                    <span className="text-blue fs-3 fw-bold">
                                        {moneyFormatter(getOutBl(tableId).balance, balance.currencyCode)}
                                    </span>
                            </div>
                        </div>
                        <div className="text-center pe-2">
                            <div>
                                    <span className="fw-bold">
                                        <I18n t={"BALANCE"}/>
                                    </span>
                            </div>
                            <div>
                                    <span className="text-blue fs-3 fw-bold">
                                        {moneyFormatter(balance.balance, balance.currencyCode)}
                                    </span>
                            </div>
                        </div>
                    </div>

                    <Form className="d-flex justify-content-center align-items-center p-4 d-lg-none">
                        <Form.Group controlId="radioGroup" className="d-flex justify-content-center align-items-center">
                            {[<I18n t={"BETTING"}/>, <I18n t={"TICKET"}/>].map((label, index) => {
                                return <Form.Check
                                    key={index}
                                    type="radio"
                                    label={label}
                                    name="radioGroup"
                                    value={index}
                                    className="mx-5"
                                    checked={selectedOption === index}
                                    onChange={() => handleRadioChange(index)}
                                />
                            })
                            }
                        </Form.Group>
                    </Form>
                    <div className={clsx("row m-0 history-dice", {
                        "d-none": selectedOption === 1
                    })}>
                        <div className="col-lg-6">
                            <BettingBoard draw={draw}/>
                        </div>
                        <div className="col-lg-6 mt-1">
                            <div className="history-header-dice p-1">
                                <div className="text-light fs-4 fw-bolder ms-2"><I18n t={"RESULT"}/></div>
                            </div>
                            <HistoryTable/>
                        </div>
                    </div>
                    <div className={clsx({
                        "d-none": selectedOption === 0
                    })}>
                        <RecentBetPage/>
                    </div>

                </div>
            </div>
            <ToastContainer/>
        </MainCard>
    )
}

export default GameWrapper;
